import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'ui/Button';
import StyledDialog from 'ui/StyledComponents/StyledDialog';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const SaftModal = ({ open, onClose, onClick }) => {
  const [saftReady, setSaftReady] = useState(false);

  const handleDownload = () => {
    if (saftReady) {
      onClick('saft');
    } else {
      onClick();
    }
    setSaftReady(false);
    onClose();
  };

  const handleClose = () => {
    setSaftReady(false);
    onClose();
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle>Export Orders</DialogTitle>
      <DialogContent dividers>
        <FormControlLabel
          control={
            <Checkbox
              checked={saftReady}
              onChange={(e) => setSaftReady(e.target.checked)}
            />
          }
          label="Export ready for accounting software (VAT included)"
        />
      </DialogContent>
      <DialogActions>
        <Button
          secondary
          minwidth
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          highlighted
          minwidth
          onClick={handleDownload}
        >
          Download
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

SaftModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SaftModal;

